import _ from 'lodash'

export const icon = 'treasure-chest'
export const humanName = {
  singular: 'Lojinha',
  plural: 'Lojinha'
}
export const statuses = [
  { slug: 'pending', name: 'Aguardando aprovação', variant: 'warning' },
  { slug: 'approved', name: 'Aprovado', variant: 'success' },
  { slug: 'refused', name: 'Recusado', variant: 'danger' },
  { slug: 'awaiting_correction', name: 'Aguardando correção', variant: 'dark' }
]
export const getStatus = slug => _.find(statuses, { slug })
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/lojinha'
  const apiBasePath = `/user/digital_products/${digitalProductId}/rewards`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    getBreadcrumbs,
    statuses,
    getStatus
  }

  return config
}
